import { create } from "zustand"

interface NavigationLeftState {
  id: string
  setId: (id: string) => void
}

export const useShowCampaign = create<NavigationLeftState>((set) => ({
  id: "",
  setId: (id) => set({ id })
}))
